import type { WidgetOptions } from 'redux/modules/superreports.types';
import { WidgetDataType } from 'redux/modules/superreports.types';

// lists types
export const WIDGET_PROJECTS_LIST = 'projects:list';
export const WIDGET_USERS_LIST = 'users:list';
export const WIDGET_LABELS_LIST = 'labels:list';
export const WIDGET_CLIENTS_LIST = 'clients:list';
export const WIDGET_TEAMS_LIST = 'teams:list';
export const WIDGET_LINKED_WORK_LIST = 'linked_work:list';
export const WIDGET_LINKED_WORK_DONUT = 'linked_work:donut';

export const WIDGET_AGENTS_LINE = 'agents:line';
export const WIDGET_AGENTS_LIST = 'agents:list';
export const WIDGET_AGENTS_DONUT = 'agents:donut';
export const AGENT_WIDGETS = [WIDGET_AGENTS_LINE, WIDGET_AGENTS_LIST, WIDGET_AGENTS_DONUT];

// graphs
export const WIDGET_PROJECTS_HBAR = 'projects:hbar';
export const WIDGET_USERS_HBAR = 'users:hbar';
export const WIDGET_LABELS_HBAR = 'labels:hbar';
export const WIDGET_CLIENTS_HBAR = 'clients:hbar';
export const WIDGET_HOURS_LINE = 'hours:line';
export const WIDGET_HOURS_CUMULATIVE_LINE = 'hours:line-cm';
export const WIDGET_PLANNED_VS_LOGGED = 'plannedvslogged:line';
export const WIDGET_BILLABLE_VS_NON_BILLABLE_LINE = 'billable:line';

// group widgets by content type
export const WIDGET_TYPE_USERS = [WIDGET_USERS_LIST, WIDGET_USERS_HBAR];
export const WIDGET_TYPE_PROJECTS = [
  WIDGET_PROJECTS_LIST,
  WIDGET_PROJECTS_HBAR,
  WIDGET_CLIENTS_LIST,
];
export const WIDGET_TYPE_LABELS = [WIDGET_LABELS_LIST, WIDGET_LABELS_HBAR];
export const WIDGET_TYPE_CLIENTS = [WIDGET_CLIENTS_HBAR];
export const WIDGET_TYPE_TEAMS = [WIDGET_TEAMS_LIST];
export const WIDGET_TYPE_LINKED_WORK = [WIDGET_LINKED_WORK_LIST, WIDGET_LINKED_WORK_DONUT];

// group widgets by visual type
export const HBAR_WIDGETS = [
  WIDGET_CLIENTS_LIST, // Despite the name, we want HBAR's on this list.
  WIDGET_USERS_HBAR,
  // WIDGET_TEAMS_LIST,
  WIDGET_LABELS_HBAR,
  WIDGET_PROJECTS_HBAR,
  WIDGET_CLIENTS_HBAR,
];

export const TABLE_WIDGETS = [
  WIDGET_USERS_LIST,
  WIDGET_USERS_HBAR,
  WIDGET_PROJECTS_LIST,
  WIDGET_PROJECTS_HBAR,
  WIDGET_LABELS_LIST,
  WIDGET_LABELS_HBAR,
  WIDGET_CLIENTS_LIST,
  WIDGET_CLIENTS_HBAR,
  WIDGET_TEAMS_LIST,
  WIDGET_LINKED_WORK_LIST,
];

export const TIMELINE_WIDGETS = [
  WIDGET_HOURS_LINE,
  WIDGET_HOURS_CUMULATIVE_LINE,
  WIDGET_BILLABLE_VS_NON_BILLABLE_LINE,
];

export const WIDGET_PROJECTS_DONUT = 'projects:donut';
export const WIDGET_CLIENTS_DONUT = 'clients:donut';
export const WIDGET_TEAMS_DONUT = 'teams:donut';
export const WIDGET_BILLED_VS_UNBILLED_DONUT = 'hours:donut';
export const WIDGET_BILLABLE_VS_NON_BILLABLE_DONUT = 'billable:donut';
export const WIDGET_LABELS_DONUT = 'labels:donut';

export const DONUT_WIDGETS = [
  WIDGET_PROJECTS_DONUT,
  WIDGET_CLIENTS_DONUT,
  WIDGET_TEAMS_DONUT,
  WIDGET_BILLED_VS_UNBILLED_DONUT,
  WIDGET_BILLABLE_VS_NON_BILLABLE_DONUT,
  WIDGET_LABELS_DONUT,
  WIDGET_LINKED_WORK_DONUT,
];

export const DEFAULT_WIDGET_OPTIONS: WidgetOptions = {
  dataType: WidgetDataType.Hours,
};

export const COMPATIBLE_WIDGETS = [
  ...AGENT_WIDGETS,
  ...HBAR_WIDGETS,
  ...TABLE_WIDGETS,
  ...TIMELINE_WIDGETS,
  ...DONUT_WIDGETS,
];

export const WIDGET_DRAGGABLE_ITEM_TYPE = Symbol('widget');

export const WIDGET_DATA_SUBJECTS: Record<string, string | undefined> = {
  ...WIDGET_TYPE_USERS.reduce<Record<string, string>>((temp, widgetType) => {
    temp[widgetType] = 'user';
    return temp;
  }, {}),
  ...[...WIDGET_TYPE_CLIENTS, ...WIDGET_TYPE_PROJECTS].reduce<Record<string, string>>(
    (temp, widgetType) => {
      temp[widgetType] = 'project';
      return temp;
    },
    {}
  ),
  ...WIDGET_TYPE_LABELS.reduce<Record<string, string>>((temp, widgetType) => {
    temp[widgetType] = 'tag';
    return temp;
  }, {}),
  ...WIDGET_TYPE_LINKED_WORK.reduce<Record<string, string>>((temp, widgetType) => {
    temp[widgetType] = 'linked_work';
    return temp;
  }, {}),
};

export const NON_MONEY_WIDGETS = [
  WIDGET_BILLED_VS_UNBILLED_DONUT,
  WIDGET_BILLABLE_VS_NON_BILLABLE_DONUT,
];
